<template>
  <div class="pl-5 pr-5 mt-5">
    <div class="title">
      <v-icon class="indent pr-1">mdi-square-medium</v-icon>
      <span class="">{{ title }}</span>
    </div>

    <div class="font-weight-light mt-3">
      <p>
        Aplikace je určena pro zákazníky stravovacích provozů, restaurací a jídelen.
        Umožňuje zadávat objednávky předdefinovaných jídel a zobrazovat různé reporty
        ohledně konzumace, pohybů na zákaznických účtech a podobně. Aplikace má vlastní
        administrátorské rozhraní, je plně skinovatelná.
      </p>

      <div class="subtitle-1">
        <span>Restaurace a jídelny, které aplikaci používají (výčet):</span>
      </div>

      <ul class="mt-3">
        <li><a class="theme--light" href="//www.ambi.cz" target="_blank">Ambiente (WebCare)</a></li>
        <li><a href="//www.crosscafe.cz/" target="_blank">Crosscafe (WebCare)</a></li>
        <li><a href="//sokorest.cz/" target="_blank">Sokorest (WebCare – zabezpečení self-signed certifikátem)</a></li>
        <li><a href="//hyundai-motor.cz/" target="_blank">Hyundai (WebCare)</a></li>
        <li><a href="//www.zatisigroup.cz/zatisi-club-cz.htm" target="_blank">Zátiší Club (WebCare)</a></li>
        <li><a href="//www.mojekredenc.cz/" target="_blank">Moje Kredenc (WebCare)</a></li>
        <li><a href="//www.rferl.org/" target="_blank">RFE/RL (firemní stravování, pouze intranet)</a></li>
        <li><a href="//www.sazka.cz/" target="_blank">Sazka (firemní stravování, pouze intranet)</a></li>
      </ul>

      <div class="subtitle-1 mt-3">
        <span>Použité technologie:</span>
      </div>

      <ul class="mt-3">
        <li>PHP (Zend framework)</li>
        <li>HTML</li>
        <li>jQuery</li>
        <li>AJAX</li>
      </ul>
    </div>

    <ImgCarousel :items="images" @click="click"></ImgCarousel>
    
  </div>
</template>

<script>
  import { call } from 'vuex-pathify';

  import ImgCarousel from "@/components/ImgCarousel";

  export default {
    name: "Webcare",
    components: {
      ImgCarousel
    },
    data () {
      return {
        title: 'WebCare - objednávkový a reportovací systém',
        images: [
          {
            src: '/img/refs/webcare/01.png',
            description: 'Vzhled stránky objednávek',
            alt: ''
          },
          {
            src: '/img/refs/webcare/02.png',
            description: 'Vzhled stránky reportů',
            alt: ''
          },
          {
            src: '/img/refs/webcare/03.png',
            description: 'Jiný vzhled stránky reportů pro restauraci Ambiente',
            alt: ''
          },
        ]
      }
    },
    methods: {
      ...call('imgGallery', ['showGallery']),
      click (item) {
        this.showGallery({
          items: this.images,
          index: item.index,
          title: this.title
        });
      }
    }
  }
</script>

<style scoped>
  a {
    color: rgba(8, 113, 0, 0.87);
    text-decoration: none;
  }
  a:hover {
    border-bottom: 1px solid;
  }
  .indent {
    margin-left: -7px;
    margin-top: -2px;
  }
</style>